import { Drawer, Tabs, Spin, Tooltip } from 'antd'
import styled from 'styled-components'
import { SignTitle } from '@/components/sign-title'
import { IconFont, SvgIcon, TagDetail } from '@/components'
import MarkdownEditor from '@/components/markdown-editor'
import DetailLog from './detail-log'
import moment from 'moment'
import { t } from '@/i18n'

export const DetailDrawer = props => {
  const { visible = true, onClose, dataList, logList = [], loading } = props

  const href = (protocol, item, data) => {
    let url
    if (protocol?.toLowerCase() === 'http' || protocol?.toLowerCase() === 'https') {
      if (item.type === 'md5') {
        url = item.link + data.url_md5
      } else if (item.type === 'sha256') {
        url = item.link + data.url_sha256
      }
    } else if (protocol?.toLowerCase() === 'dns') {
      if (item.name === '微步在线') {
        url = `https://x.threatbook.com/v5/domain/${data.resource_name}`
      } else if (item.name === 'VirusTotal') {
        url = `https://www.VirusTotal.com/gui/file/${data.resource_name}`
      }
    } else if (protocol?.toLowerCase() === 'tcp') {
      const ipPattern = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/
      const domainPattern = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/
      let name = data.resource_name.split(':')[0]
      if (item.name === '微步在线') {
        if (ipPattern.test(name)) {
          url = `https://x.threatbook.com/v5/ip/${name}`
        } else {
          url = `https://x.threatbook.com/v5/domain/${name}`
        }
      } else if (item.name === 'VirusTotal') {
        if (ipPattern.test(name)) {
          url = `https://www.VirusTotal.com/gui/ip/${name}`
        } else if (domainPattern.test(name)) {
          url = `https://www.VirusTotal.com/gui/domain/${name}`
        }
      }
    }
    return url
  }

  // 置信度组件
  const ConfidenceLevel = () => {
    if (dataList?.confidence_level === 'ConfidenceLevelLow') {
      return <SvgIcon name="置信度-低" width={92} className="confidence" />
    }
    if (dataList?.confidence_level === 'ConfidenceLevelMid') {
      return <SvgIcon name="置信度-中" width={92} className="confidence" />
    }
    return <SvgIcon name="置信度-高" width={92} className="confidence" />
  }

  // 拦截状态组件
  const InterceptStatus = () => {
    if (dataList?.intercept_status === 'intercept_status_intercept_success') {
      return <div className="intercept">{t('拦截成功')}</div>
    }
    if (dataList?.intercept_status === 'intercept_status_intercept_defence_fail') {
      return <div className="intercept-err">{t('防护失效')}</div>
    }
    if (dataList?.intercept_status === 'intercept_status_detect_success') {
      return (
        <div className="intercept-err" style={{ color: '#72b851', background: '#e9f5e3' }}>
          {t('检测成功')}
        </div>
      )
    }
    return null
  }

  const ResoutLevel = () => {
    if (dataList?.resource_level === 'ResourceLevelSenior') {
      return <div className="resout-level">{t('高级')}</div>
    }
    if (dataList?.resource_level === 'ResourceLevelMiddle') {
      return <div className="resout-level">{t('中级')}</div>
    }
    if (dataList?.resource_level === 'ResourceLevelJunior') {
      return <div className="resout-level">{t('初级')}</div>
    }
    return <p className="name">-</p>
  }

  // 危险等级组件
  const RiskLevel = () => {
    const riskMap = {
      RiskLevelLow: t('低危'),
      RiskLevelMiddle: t('中危'),
      RiskLevelHigh: t('高危'),
      RiskLevelGross: t('严重'),
    }
    return <p className="name">{riskMap[dataList?.risk_level] || '-'}</p>
  }

  // ATT&CK 组件
  const AttackTactics = () => {
    if (!dataList?.tactic_list?.length) return null

    return (
      <div className="flex" style={{ marginTop: '24px', justifyContent: 'flex-start' }}>
        <span className="title" style={{ width: '115px' }}>
          ATT&CK:
        </span>
        <div style={{ width: '295px' }}>
          {dataList.tactic_list.map(item => (
            <div key={item.id} style={{ marginBottom: '6px' }}>
              <a href={item.url} target="_blank" rel="noopener noreferrer">
                {item.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    )
  }

  // 参考链接组件
  const ReferenceLinks = () => {
    if (!dataList?.items) return null

    const filteredItems = dataList.items.filter(item => item.name !== 'Norton SafeWeb')

    return (
      <div className="block">
        <p className="title">{t('参考：')}</p>
        <div className="content">
          {filteredItems.map((item, index) => (
            <div key={index} style={{ margin: '4px' }}>
              <a
                href={href(dataList?.protocol, item, dataList)}
                rel="noopener noreferrer"
                target="_blank"
              >
                <IconFont type="icon-tiaozhuan" style={{ color: '#031A79', marginRight: 10 }} />
                {item.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const BasicInfo = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          <ConfidenceLevel />
          <div className="flex">
            <p className="title">{t('用例名称：')}</p>
            <Tooltip title={dataList?.case_name || '-'} placement="topLeft">
              <p className="name" style={{ width: 'calc(98% - 215px)' }}>
                {dataList?.case_name || '-'}
              </p>
            </Tooltip>
          </div>
          <div className="flex">
            <p className="title">{t('验证模式：')}</p>
            <p className="name">{t('Agent → 外部情报')}</p>
          </div>
          {dataList?.resource_tag_list && dataList?.resource_tag_list?.length > 0 && (
            <TagDetail resourceTagList={dataList?.resource_tag_list} />
          )}
          {dataList?.protocol && (
            <div className="flex">
              <p className="title">协议类型：</p>
              <p className="name">{dataList?.protocol || '-'}</p>
            </div>
          )}
          <div className="flex">
            <p className="title">{t('用例资源：')}</p>
            <Tooltip title={dataList?.resource_name || '-'} placement="topLeft">
              <p className="name">{dataList?.resource_name || '-'}</p>
            </Tooltip>
          </div>
          <div className="flex">
            <p className="title">{t('模板：')}</p>
            <p className="name">{dataList?.template_name_list.join(',') || '-'}</p>
          </div>
          <div className="flex">
            <p className="title">{t('攻击类型：')}</p>
            <p className="name">{dataList?.attack_type_name || '-'}</p>
          </div>
          <div className="flex">
            <p className="title">{t('危险等级：')}</p>
            <RiskLevel />
          </div>
          <div className="flex">
            <p className="title">{t('拦截状态：')}</p>
            <InterceptStatus />
            {dataList?.intercept_from === 'interception_from_manual_correct' && (
              <span
                style={{
                  marginLeft: 5,
                  borderRadius: 6,
                  padding: '0 2px',
                  fontSize: 12,
                  color: '#1bbc40',
                  background: '#d9f4df',
                  height: 20,
                  lineHeight: '20px',
                }}
              >
                {t('已修正')}
              </span>
            )}
          </div>
          <div className="flex">
            <p className="title">{t('用例分级：')}</p>
            <ResoutLevel />
          </div>
          <div className="flex">
            <p className="title">{t('更新时间：')}</p>
            <p className="name">
              {dataList?.updateTime
                ? moment(dataList?.updateTime).format('YYYY-MM-DD HH:mm:ss')
                : '-'}
            </p>
          </div>
          {dataList?.protocol && (
            <div className="flex">
              <p className="title">{t('协议类型：')}</p>
              <p className="name">{dataList?.protocol || '-'}</p>
            </div>
          )}
          <AttackTactics />
          {dataList?.apt_name && (
            <div className="flex">
              <p className="title">{t('攻击组织：')}</p>
              <p className="name">{dataList?.apt_name || '-'}</p>
            </div>
          )}
          <ReferenceLinks />
          {dataList?.describe && (
            <div className="block">
              <p className="title">{t('用例描述：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.describe}
              />
            </div>
          )}
          {dataList?.solution && (
            <div className="block">
              <p className="title">{t('解决方案：')}</p>
              <MarkdownEditor
                isEdit={false}
                onlyDisplay
                setValue={() => {}}
                value={dataList?.solution}
              />
            </div>
          )}
        </>
      )}
    </DetailDrawerBox>
  )

  const AttackDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="flex">
            <p className="title">{t('执行开始时间：')}</p>
            <p className="name">{dataList?.attack_detail?.execStartTime || '-'}</p>
          </div>
          <div className="flex">
            <p className="title">{t('执行结束时间：')}</p>
            <p className="name">{dataList?.attack_detail?.execEndTime || '-'}</p>
          </div>
          <div className="flex">
            <p className="title">{t('请求源IP：')}</p>
            <p className="name">{dataList?.attack_detail?.requestSourceIp || '-'}</p>
          </div>
          <div className="flex">
            <p className="title">{t('请求地址：')}</p>
            <p className="name">{dataList?.attack_detail?.requestAddress || '-'}</p>
          </div>
        </>
      )}
    </DetailDrawerBox>
  )

  const LogDetail = () => (
    <DetailDrawerBox>
      {loading ? (
        <Spin />
      ) : (
        <div className="log-alarm">
          <div className="log-alarm-title">{t('告警日志：')}</div>
          {logList?.map((item, index) => (
            <DetailLog index={index} data={item} key={index} dataList={dataList} />
          ))}
        </div>
      )}
    </DetailDrawerBox>
  )

  return (
    <DetailDrawerContainer>
      <Drawer
        title={<SignTitle show>{t('用例详情')}</SignTitle>}
        placement="right"
        closable
        onClose={onClose}
        visible={visible}
        width={600}
        destroyOnClose
      >
        <Tabs
          defaultActiveKey="1"
          items={
            logList.length > 0
              ? [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                  { label: t('告警日志'), key: '3', children: <LogDetail /> },
                ]
              : [
                  { label: t('用例信息'), key: '1', children: <BasicInfo /> },
                  { label: t('攻击详情'), key: '2', children: <AttackDetail /> },
                ]
          }
        />
      </Drawer>
    </DetailDrawerContainer>
  )
}

const DetailDrawerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const DetailDrawerBox = styled.div`
  .confidence {
    position: absolute;
    right: 14px;
    top: -45px;
  }
  .block {
    margin: 12px 0;
    .title {
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }
  }
  .intercept,
  .intercept-err {
    width: 64px;
    height: 20px;
    background: #e5eeff;
    border-radius: 4px 12px 4px 12px;
    font-size: 12px;
    color: #2973ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .intercept-err {
    color: #f44f4f;
    background: #fde5e5;
  }
  .content {
    word-break: break-all;
    color: #666666;
    border-radius: 4px;
    .headers {
      display: flex;
      margin-bottom: 5px;
    }
    .marked {
      white-space: nowrap;
      color: #558490;
      margin-right: 5px;
    }
    .marked-body {
      color: #558490;
    }
  }
  .header {
    // max-height: 200px;
    overflow-y: auto;
  }
  .flex,
  .flex-name {
    display: flex;
    margin-bottom: 15px;
    .content {
      color: #666666;
      border-radius: 4px;
      padding: 0 10px;
      width: calc(98% - 128px);
      background: #f7f8fa;
    }
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
      margin-bottom: 0px;
    }
    .name {
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .flex-name {
    width: 50%;
  }
  .flex-two {
    display: flex;
    .title {
      height: 14px;
      font-size: 14px;
      color: #86909c;
      line-height: 16px;
      width: 92px;
      text-align: left;
      margin-right: 18px;
      white-space: nowrap;
    }

    .name {
      width: 55%;
    }
  }
  .params {
    width: 100%;
    background: #f8f9fb;
    border-radius: 6px;
    padding: 12px;
    margin-top: 8px;
    .sample {
      border-top: 1px dashed #d5d9dd;
      padding: 10px;
      &:first-child {
        border: 0;
      }
    }
  }
  .params-flex {
    display: flex;
  }
  .params-title {
    height: 20px;
    width: 106px;
  }
`
